import { useNavigate } from "react-router-dom";
import { HelpCircle } from "lucide-react";

export default function HelpButton() {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate("/help")}
      className="fixed bottom-6 right-20 z-40 w-10 h-10 bg-slate-700 hover:bg-slate-800 text-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110"
      data-testid="floating-help-btn"
      title="Help Center"
    >
      <HelpCircle className="w-5 h-5" />
    </button>
  );
}
